<template>
  <div class="prescription-container">
    <div class="prescription-layout">
      <div class="prescription-left">
        <el-card class="prescription-header-card" shadow="never">
          <template #header>
            <div class="card-header">
              <div class="header-title">
                <span class="retail-title">零售单</span>
              </div>
              <div class="header-actions">
                <div style="margin-right: 15px; color: #fff; font-size: 14px;">
                  总计：<span style="font-size: 18px; font-weight: bold; color: #ffeb3b;">¥{{ totalAmount }}</span>
                </div>
                <el-button type="info" size="small" @click="handlePrintWestPrescription">
                  <i class="el-icon-printer"></i> 打印
                </el-button>
                <el-button type="warning" size="small" @click="openOrderList">订单列表</el-button>
                <el-button type="success" size="small" @click="handleConfirmWest">提交并发药</el-button>
              </div>
            </div>
          </template>

          <div class="prescription-form" style="padding: 12px;">
            <!-- 患者输入区（全空 = 零售购药；任意有值 = 新增患者） -->
            <div class="patient-input-section">
              <i class="el-icon-user" style="color: #409EFF; font-size: 16px; margin-right: 8px;"></i>
              <span class="section-label">患者信息：</span>
              <el-input
                  v-model.trim="patientForm.name"
                  size="mini"
                  placeholder="姓名"
                  clearable
                  style="width: 200px; margin-right: 8px;"
                  @input="handlePatientNameInput"
                  @blur="handlePatientNameBlur"
                  @clear="handlePatientNameClear"
                  @keydown.enter.native.prevent="handlePatientNameEnter"
                  @compositionstart.native="handleNameCompositionStart"
                  @compositionend.native="handleNameCompositionEnd" />
              <el-input
                  v-model.trim="patientForm.tel"
                  size="mini"
                  placeholder="联系电话"
                  clearable
                  style="width: 160px; margin-right: 8px;" />
              <el-input
                  v-model.trim="patientForm.certno"
                  size="mini"
                  placeholder="身份证"
                  clearable
                  style="width: 220px; margin-right: 8px;"
                  @input="handlePatientCertInput" />

              <!-- 零售单号（订单号）：跟在身份证后，只读展示 -->
              <span class="section-label" style="margin-left: 4px; white-space: nowrap;">订单号：</span>
              <el-input
                  :value="retailOrderNo"
                  size="mini"
                  :readonly="true"
                  placeholder="单号加载中..."
                  class="order-no-display"
                  style="width: 210px; margin-right: 8px;">
                <i slot="prefix" class="el-icon-document" style="color: #409EFF; line-height: 28px;"></i>
              </el-input>

              <!-- ============ 新增：日期显示（仅年月日） ============ -->
              <span class="section-label" style="margin-left: 4px; white-space: nowrap;">日期：</span>
              <el-input
                  :value="currentDate"
                  size="mini"
                  :readonly="true"
                  class="order-no-display"
                  style="width: 130px; margin-right: 8px;">
                <i slot="prefix" class="el-icon-date" style="color: #409EFF; line-height: 28px;"></i>
              </el-input>
              <!-- ============ 新增结束 ============ -->
            </div>

            <!-- 精简西药表格 -->
            <el-table
                size="small"
                ref="westMedicineTableData"
                :data="westMedicineTableData"
                border
                style="width: 100%"
                highlight-current-row
                row-key="id">
              <el-table-column label="操作" width="70" align="center">
                <template slot-scope="scope">
                  <el-button
                      v-if="canRemoveWest()"
                      size="mini"
                      type="text"
                      @click="removeWestMedicineTableData(scope.$index)">移除
                  </el-button>
                  <span v-else style="color: #c0c4cc;">-</span>
                </template>
              </el-table-column>

              <el-table-column label="药品名称" min-width="200" align="center">
                <template slot-scope="scope">
                  <el-popover
                      placement="bottom-start"
                      trigger="click"
                      width="750"
                      v-model="scope.row._popoverVisible"
                      popper-class="modern-medicine-popover">
                    <div style="max-height: 400px; overflow: auto;">
                      <el-table
                          :data="scope.row._searchResults"
                          border
                          size="mini"
                          v-loading="scope.row._searchLoading"
                          highlight-current-row
                          @row-click="(row) => handleSelectDrugFromPopover(scope.row, row)">
                        <el-table-column
                            v-for="(col, index) in tableRows11"
                            :key="index"
                            :prop="col.prop"
                            :label="col.name"
                            align="center"
                            :min-width="getColumnWidth(col.name, col.prop, scope.row._searchResults)">
                          <template #default="{ row }">
                            {{ safeGetMappedValue(col, row) }}
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <el-input
                        slot="reference"
                        size="mini"
                        v-model="scope.row.drugName"
                        placeholder="输入药名检索，或扫追溯码"
                        @input="(val) => searchDrugsForRow(scope.row, val)"
                        @keydown.enter.native.prevent="handleDrugNameEnter(scope.$index, scope.row)">
                    </el-input>
                  </el-popover>
                </template>
              </el-table-column>

              <el-table-column label="规格" min-width="120" align="center">
                <template slot-scope="scope">
                  <span style="color: #606266;">{{ scope.row.pacSpec || '-' }}</span>
                </template>
              </el-table-column>

              <el-table-column label="销售单位" width="130" align="center">
                <template slot-scope="scope">
                  <el-select
                      size="mini"
                      v-model="scope.row.saleUnt"
                      @change="calcWestRowAmount(scope.row)"
                      placeholder="请选择">
                    <el-option
                        v-for="item in scope.row.saleUntOption || []"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="单价" width="100" align="center">
                <template slot-scope="scope">
                  <span style="color: #F56C6C; font-weight: 500;">¥{{ getUnitPrice(scope.row) }}</span>
                </template>
              </el-table-column>

              <el-table-column label="购买数量" width="130" align="center">
                <template slot-scope="scope">
                  <el-input-number
                      :min="0.0001"
                      :precision="3"
                      v-model="scope.row.cnt"
                      @change="calcWestRowAmount(scope.row)"
                      size="mini"
                      placeholder="数量">
                  </el-input-number>
                </template>
              </el-table-column>

              <el-table-column label="金额" width="120" align="center">
                <template slot-scope="scope">
                  <span style="color: #F56C6C; font-weight: 600; font-size: 14px;">
                    ¥{{ scope.row.saleAmt || '0.00' }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="备注" min-width="120" align="center">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.remark" placeholder="备注"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
    </div>

    <div class="dialog">
      <!-- ========================================================= -->
      <!-- 同名患者选择弹窗 -->
      <!-- ========================================================= -->
      <el-dialog
          title="请确认患者信息"
          :visible.sync="patientMatchDialogVisible"
          width="760px"
          :close-on-click-modal="false"
          append-to-body
          class="patient-match-dialog"
          @closed="handlePatientMatchClosed">
        <div class="match-tip">
          根据姓名「<span class="match-name">{{ patientMatchKeyword }}</span>」查询到
          <span class="match-count">{{ patientMatchList.length }}</span> 位同名患者，
          <template v-if="patientMatchCertInput"> 但未找到身份证号完全一致的患者，</template>
          请确认是否为同一人，或选择"新增患者"。
        </div>

        <el-table
            :data="patientMatchList"
            border
            size="mini"
            max-height="380"
            highlight-current-row>
          <el-table-column type="index" label="行号" width="55" align="center" />
          <el-table-column prop="name" label="姓名" width="100" align="center" />
          <el-table-column label="性别" width="70" align="center">
            <template slot-scope="scope">{{ getSexLabel(scope.row.sex) }}</template>
          </el-table-column>
          <el-table-column label="年龄" width="70" align="center">
            <template slot-scope="scope">{{ getPatientAge(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="身份证号" min-width="190" align="center">
            <template slot-scope="scope">
              <span :style="isCertMatch(scope.row)
                  ? 'color:#67C23A;font-weight:bold;'
                  : 'color:#606266;'">
                {{ scope.row.certno || '未登记' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="tel" label="联系电话" width="130" align="center">
            <template slot-scope="scope">{{ scope.row.tel || '-' }}</template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="150" align="center">
            <template slot-scope="scope">
              {{ scope.row.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="110" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="chooseMatchedPatient(scope.row)">
                使用该患者
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="patientMatchDialogVisible = false">取消</el-button>
          <el-button size="mini" type="warning" @click="confirmCreateNewPatient">
            以上都不是，新增患者
          </el-button>
        </span>
      </el-dialog>

      <!-- 门诊支付窗口 -->
      <el-dialog
          title="门诊支付窗口"
          :close-on-click-modal="false"
          :visible.sync="settleAccountsDialogVisible"
          width="800px"
          class="payment-dialog"
          @closed="handlePaymentDialogClosed">
        <el-form :model="paymentForm" label-width="100px" class="payment-form">
          <div class="form-section">
            <div class="wallet-balance" style="margin-bottom: 15px; padding: 10px; background: #f0f9eb; border-radius: 4px;">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div style="font-size: 12px; color: #67C23A;">当前充值余额：{{ currentRecahrgeAmt }} 元</div>
                </el-col>
                <el-col :span="12">
                  <div style="font-size: 12px; color: #E6A23C;">当前赠送余额：{{ currentHandselAmt }} 元</div>
                </el-col>
              </el-row>
            </div>

            <template v-if="dynamicPaymentMethods.length > 0">
              <el-row v-for="(row, index) in dynamicPaymentRows" :key="index" :gutter="20" class="payment-row">
                <el-col v-for="method in row" :key="method.id" :span="8">
                  <el-form-item :label="method.wayName + ':'" class="payment-item">
                    <div style="display: flex; gap: 5px;">
                      <el-input
                          v-model.number="dynamicPaymentValues[method.id]"
                          type="number"
                          step="0.01"
                          size="small"
                          @change="calculateDynamicPayments"
                          style="flex: 1;">
                        <template slot="suffix">
                          <span class="assign-btn" @click.stop="handleAssignPayment(method.id)">分配</span>
                        </template>
                      </el-input>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <div v-else style="text-align: center; padding: 20px; color: #999;">正在加载支付方式...</div>

            <el-row>
              <el-col :span="24">
                <el-form-item label="备注:">
                  <el-input size="small" type="textarea" v-model="paymentForm.remarks" :rows="2" placeholder="请输入备注信息"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="payment-summary" style="margin-top: 20px; padding: 15px; background: #f5f7fa; border-radius: 4px;">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="应付金额:" class="compact-item">
                    <span class="amount" style="color: #F56C6C; font-weight: bold; font-size: 16px;">¥{{ outpatientChargesForm.currentTotal }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收到金额:" class="compact-item">
                    <el-input ref="recdAmt" size="small" v-model="paymentForm.recdAmt" class="compact-input" @input="onRecdAmtChange" style="width: 120px;"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="应退找零:" class="compact-item">
                    <span class="amount" style="color: #67C23A; font-weight: bold;">¥{{ paymentForm.change }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="form-actions">
            <el-button type="primary" @click="handleConfirmCharge" :loading="chargeLoading" size="medium">确认支付</el-button>
            <el-button type="warning" @click="handleClosePayment" size="medium">退出支付</el-button>
          </div>
        </el-form>
      </el-dialog>

      <!-- ========================================================= -->
      <!-- 订单列表 -->
      <!-- ========================================================= -->
      <el-dialog
          title="订单列表"
          :visible.sync="orderListDialogVisible"
          width="85%"
          :close-on-click-modal="false"
          class="order-list-dialog"
          @closed="handleOrderListClosed">
        <div class="order-list-wrap">
          <div class="order-search-bar">
            <el-form :model="orderListSearchForm" label-width="80px" size="mini" inline>
              <el-form-item label="订单号:">
                <el-input
                    v-model="orderListSearchForm.chargeNo"
                    placeholder="请输入订单号"
                    clearable
                    style="width:170px;"
                    @keyup.enter.native="handleOrderListSearch" />
              </el-form-item>
              <el-form-item label="患者姓名:">
                <el-input
                    v-model="orderListSearchForm.patientName"
                    placeholder="请输入患者姓名"
                    clearable
                    style="width:130px;"
                    @keyup.enter.native="handleOrderListSearch" />
              </el-form-item>
              <el-form-item label="收费类型:">
                <el-select
                    v-model="orderListSearchForm.chargeType"
                    placeholder="全部"
                    clearable
                    style="width:140px;"
                    @change="handleOrderListSearch">
                  <el-option label="预约挂号收费" :value="1" />
                  <el-option label="处方订单收费" :value="2" />
                </el-select>
              </el-form-item>
              <el-form-item label="收费状态:">
                <el-select
                    v-model="orderListSearchForm.status"
                    placeholder="全部"
                    clearable
                    style="width:120px;"
                    @change="handleOrderListSearch">
                  <el-option label="已收费" :value="1" />
                  <el-option label="部分退款" :value="2" />
                  <el-option label="全额退款" :value="3" />
                </el-select>
              </el-form-item>
              <el-form-item label="收费时间:">
                <el-date-picker
                    v-model="orderListSearchForm.timeRange"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    style="width:340px;"
                    @change="handleOrderListSearch" />
              </el-form-item>
              <el-form-item>
                <el-button size="mini" @click="handleOrderListSearch">查询</el-button>
                <el-button size="mini" @click="handleOrderListReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <div class="order-list-table-wrap">
            <el-table
                :data="orderListTableData"
                border
                size="mini"
                height="100%"
                highlight-current-row
                v-loading="orderListLoading"
                @row-dblclick="handleOrderRowDblclick">
              <el-table-column label="行号" type="index" width="55" align="center" />
              <el-table-column prop="chargeNo" label="订单号" min-width="180" align="center" show-overflow-tooltip />
              <el-table-column prop="patientName" label="患者姓名" width="100" align="center" />
              <el-table-column label="收费类型" width="130" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.chargeType === 1 ? 'primary' : 'success'" size="mini">
                    {{ scope.row.chargeType === 1 ? '预约挂号收费' : '处方订单收费' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="原价总金额" width="120" align="center">
                <template slot-scope="scope">
                  ¥{{ (scope.row.totalAmount || 0).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column label="实付总金额" width="120" align="center">
                <template slot-scope="scope">
                  <span style="color:#67C23A; font-weight:bold;">¥{{ (scope.row.paidAmount || 0).toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="当前净收金额" width="130" align="center">
                <template slot-scope="scope">
                  <span style="color:#409EFF; font-weight:bold;">¥{{ (scope.row.netAmount || 0).toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="已退款总金额" width="130" align="center">
                <template slot-scope="scope">
                  <span style="color:#F56C6C;">¥{{ (scope.row.refundedAmount || 0).toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="收费状态" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="getStatusType(scope.row.status)" size="mini">
                    {{ getStatusLabel(scope.row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="收费时间" min-width="160" align="center">
                <template slot-scope="scope">
                  {{ scope.row.chargeTime ? dayjs(scope.row.chargeTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="90" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click.stop="handleOrderRowDblclick(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="order-pagination">
            <el-pagination
                @size-change="handleOrderListSizeChange"
                @current-change="handleOrderListCurrentChange"
                :current-page="orderListPageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="orderListPageSize"
                :total="orderListTotalSize"
                layout="total, sizes, prev, pager, next, jumper"
                background />
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="orderListDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>

      <!-- ========================================================= -->
      <!-- 订单详情 -->
      <!-- ========================================================= -->
      <el-dialog
          title="订单详情"
          :visible.sync="detailDialogVisible"
          width="80%"
          :close-on-click-modal="false"
          class="detail-dialog"
          @closed="handleDetailClosed">
        <div v-loading="detailLoading" class="detail-layout">
          <div class="detail-header">
            <el-form size="mini" label-width="90px" disabled>
              <el-row :gutter="16">
                <el-col :span="5">
                  <el-form-item label="订单号:">
                    <el-input v-model="detailData.chargeNo" />
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="患者:">
                    <el-input v-model="detailData.patientName" />
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="状态:">
                    <el-tag :type="getStatusType(detailData.status)" size="mini">
                      {{ getStatusLabel(detailData.status) }}
                    </el-tag>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="收费时间:">
                    <el-input :value="detailData.chargeTime ? dayjs(detailData.chargeTime).format('YYYY-MM-DD HH:mm:ss') : '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="实付总金额:">
                    <el-input :value="'¥' + (detailData.paidAmount || 0).toFixed(2)" style="color:#67C23A; font-weight:bold;" />
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="已退总金额:">
                    <el-input :value="'¥' + (detailData.refundedAmount || 0).toFixed(2)" style="color:#F56C6C;" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="5">
                  <el-form-item label="可退总金额:">
                    <el-input :value="'¥' + (detailData.refundableAmount || 0).toFixed(2)" style="color:#409EFF; font-weight:bold;" />
                  </el-form-item>
                </el-col>
                <el-col :span="19">
                  <el-form-item label="收费类型:">
                    <el-input :value="getPrescriptionTypeLabel(detailPrescriptionType)" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <div class="detail-body">
            <div class="panel-title">项目明细</div>
            <div class="detail-table-wrap">
              <el-table
                  :data="detailData.items"
                  border
                  size="mini"
                  height="100%"
                  row-key="chargeItemId">
                <el-table-column type="index" label="行号" width="55" align="center" />
                <el-table-column prop="itemName" label="项目名称" min-width="180" align="center" show-overflow-tooltip />
                <el-table-column prop="specification" label="规格" min-width="120" align="center" show-overflow-tooltip />
                <el-table-column label="类型" width="90" align="center">
                  <template slot-scope="scope">
                    {{ getItemTypeLabel(scope.row.itemType) }}
                  </template>
                </el-table-column>
                <el-table-column prop="unitName" label="单位" width="70" align="center" />
                <el-table-column prop="chargedQty" label="收费数量" width="90" align="center" />
                <el-table-column label="单价" width="100" align="center">
                  <template slot-scope="scope">
                    ¥{{ getDetailUnitPrice(scope.row).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="实付金额" width="110" align="center">
                  <template slot-scope="scope">
                    <span style="color:#67C23A; font-weight:bold;">¥{{ (scope.row.paidAmount || 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="已退数量" width="90" align="center">
                  <template slot-scope="scope">
                    <span style="color:#E6A23C;">{{ scope.row.refundedQty || 0 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="已退金额" width="110" align="center">
                  <template slot-scope="scope">
                    <span style="color:#F56C6C;">¥{{ (scope.row.refundedAmount || 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="可退数量" width="90" align="center">
                  <template slot-scope="scope">
                    <span style="color:#409EFF; font-weight:bold;">{{ scope.row.refundableQty || 0 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="可退金额" width="110" align="center">
                  <template slot-scope="scope">
                    <span style="color:#409EFF; font-weight:bold;">¥{{ (scope.row.refundableAmount || 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div class="detail-body" v-if="detailData.payments && detailData.payments.length > 0">
            <div class="panel-title">支付方式</div>
            <div class="detail-table-wrap">
              <el-table :data="detailData.payments" border size="mini" height="100%">
                <el-table-column type="index" label="行号" width="55" align="center" />
                <el-table-column label="支付方式" min-width="140" align="center">
                  <template slot-scope="scope">
                    {{ getDetailPayWayLabel(scope.row.payWayId) }}
                  </template>
                </el-table-column>
                <el-table-column label="支付金额" width="140" align="center">
                  <template slot-scope="scope">
                    <span style="color:#67C23A; font-weight:bold;">
                      ¥{{ (scope.row.paidAmount || scope.row.amount || 0).toFixed(2) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="已退金额" width="140" align="center">
                  <template slot-scope="scope">
                    <span style="color:#F56C6C;">¥{{ (scope.row.refundedAmount || 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="可退金额" width="140" align="center">
                  <template slot-scope="scope">
                    <span style="color:#409EFF; font-weight:bold;">¥{{ (scope.row.refundableAmount || 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getDocphrByCondtion,
  getDrugByCondition,
} from "@/api/reservation/outpatientPhysician";
import { withLoading } from "@/untils/loading";
import { getPatternPaymentList } from "@/api/patternPayment/patternPayment";
import { getAmtById } from "@/api/patientRechargeStatistics/patientRechargeStatistics";
import {
  getPatientsAwaitingPaymentByPatientId,
  fullOrderCharge,
  getChargesQuery,
  getRefundableCharges
} from "@/api/reservation/outpatientChargeV2";
import {
  generateHealthSystemId,
  uploadRetail,
  addOrdersRetail,
  getDocumentNo
} from "@/api/retailPurchaseOfMedicine/retailPurchaseOfMedicine";

import { getPatientInfoV2, fySaveV2, outpTable } from "@/api/MedicenHouse/WesternGive.js";
import { msfxCodeDetail } from "@/api/systemCatalogue/Western.js";
import { addDocphr } from "@/api/reservation/reservation";
import dayjs from 'dayjs';

// ============ 打印相关依赖 ============
import printUtil from "@/untils/printUtil";
import { westPrescription } from "@/assets/printTemplateConfig/westPrescription";
import { doccliniclist } from "@/api/cinic/cinic";

const getEmptyPatientForm = () => ({
  name: '',
  tel: '',
  certno: '',
  ntlyId: '',
});

const getEmptyOutpatientChargesForm = () => ({
  id: null, patId: null, name: null, age: null, billingDoctor: null, billingDoctorId: null,
  billingDept: null, remainingSum: null, chargeItem: null, specification: null,
  executeDept: null, price: null, amount: null, patientType: null, ticketType: 1,
  currentTicketNo: null, currentTotal: null, discountedTotal: null, BeforePatId: '',
  BeforePaidAmt: null, BeforeReceiveAmt: null, BeforeChange: null, thisTimeTotal: null,
});

const getEmptyPaymentForm = () => ({
  age: null, aliAmt: null, bankAmt: null, bebtAmt: null, bebtId: null, bebtType: '',
  bilgDepId: null, bilgDepName: '', bilgDrId: null, bilgDrName: '', cashAmt: null,
  chsAmt: null, distAmt: null, groupAmt: null, invoNo: '', opeWay: null, paidAmt: null,
  patAmt: null, patCostType: null, patId: null, patName: '', patType: null, recdAmt: null,
  receAmt: null, regId: null, remarks: '', seeId: null, sex: null, shHarId: null,
  wechatAmt: null, balance: null, observation: null, observationAdvance: null, change: null,
  ids: [], clientId: '',
});

const getEmptyWestRowData = () => ({
  id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
  drugName: '',
  drugId: '',
  pacSpec: '',
  manufacturer: '',
  saleUnt: null,
  minUntId: null,
  pacUntId: null,
  cnt: 1,
  saleAmt: null,
  remark: '',
  fixMinSalePric: 0,
  fixPacSalePric: 0,
  saleUntOption: [],
  _popoverVisible: false,
  _searchResults: [],
  _searchLoading: false,
  _searchKeyword: '',
  traceCode: '',
});

const getEmptyDetailData = () => ({
  chargeId: null,
  chargeNo: '',
  patientName: '',
  chargeTime: '',
  status: null,
  paidAmount: 0,
  refundableAmount: 0,
  refundedAmount: 0,
  items: [],
  payments: []
});

export default {
  name: 'RetailPurchaseOfMedicine',
  computed: {
    dynamicPaymentRows() {
      const rows = [];
      for (let i = 0; i < this.dynamicPaymentMethods.length; i += 3) {
        rows.push(this.dynamicPaymentMethods.slice(i, i + 3));
      }
      return rows;
    },
    totalAmount() {
      const total = this.westMedicineTableData.reduce((sum, item) => {
        return sum + (Number(item.saleAmt) || 0);
      }, 0);
      return total.toFixed(2);
    },
    hasPatientInput() {
      const { name, tel, certno } = this.patientForm;
      return !!(name || tel || certno);
    },
    patientMatchCertInput() {
      return (this.patientForm.certno || '').trim().toUpperCase();
    }
  },
  data() {
    return {
      // ===== 当前日期（仅年月日） =====
      currentDate: dayjs().format('YYYY-MM-DD'),

      // ===== 患者输入 =====
      patientForm: getEmptyPatientForm(),

      // ===== 患者匹配（同名患者复用） =====
      selectedPatient: null,
      selectedPatientId: null,
      patientMatchDialogVisible: false,
      patientMatchList: [],
      patientMatchKeyword: '',
      patientQuerying: false,
      patientResolvedName: '',
      patientNameTimer: null,
      patientNameComposing: false,

      // ===== 零售单号（订单号） =====
      retailOrderNo: '',
      documentNoLoading: false,

      // ===== 收费/支付 =====
      settleAccountsDialogVisible: false,
      chargeLoading: false,
      paymentForm: getEmptyPaymentForm(),
      outpatientChargesForm: getEmptyOutpatientChargesForm(),
      dynamicPaymentMethods: [],
      dynamicPaymentValues: {},
      currentRecahrgeAmt: '0.00',
      currentHandselAmt: '0.00',
      selectedOrderIds: [],
      totalChargeAmount: 0,
      cachedRequestNo: '',
      patientId: null,

      submittedTraceCodes: {},

      // ===== 西药表格 =====
      westMedicineTableData: [getEmptyWestRowData()],

      // ===== 基础字典 =====
      drugDosageOption: [],
      drugUntOptions: [],
      medicationWayOptions: [],
      systemParameterList: [],
      userInfo: null,
      deptOptions: [],

      // ===== 搜索表格列 =====
      tableRows11: [
        { name: "药品名称", prop: "drugName", align: "center" },
        { name: "规格", prop: "pacSpec", align: "center" },
        { name: "药品剂型", prop: "dosform", align: "center", op: 'drugDosageOption' },
        { name: "库存数量", prop: "purcCnt", align: "center" },
        { name: "包装单位", prop: "pacUnt", align: "center", op: 'drugUntOptions' },
        { name: "小单位售价", prop: "fixMinSalePric", align: "center" },
        { name: "包装售价", prop: "fixPacSalePric", align: "center" },
      ],

      drugSearchTimer: null,

      // ===== 订单列表 =====
      orderListDialogVisible: false,
      orderListLoading: false,
      orderListSearchForm: {
        chargeNo: '',
        patientName: '',
        chargeType: null,
        status: null,
        timeRange: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      orderListTableData: [],
      orderListPageNum: 1,
      orderListPageSize: 10,
      orderListTotalSize: 0,

      // ===== 订单详情 =====
      detailDialogVisible: false,
      detailLoading: false,
      detailData: getEmptyDetailData(),
      detailPrescriptionType: 'other',
      paymentMethodOptions: [],

      dayjs,
    };
  },

  async mounted() {
    try {
      await Promise.all([
        this.$store.dispatch('preload/fetchGetMedicationWayListOptions'),
        this.$store.dispatch('preload/fetchGetDeptListOptions'),
        this.$store.dispatch('preload/fetchGetDrugUntOptions'),
        this.$store.dispatch('preload/fetchGetDrugDosageListOption'),
        this.$store.dispatch('preload/fetchGetSystemListOptions')
      ]);

      this.deptOptions = this.$store.getters['preload/getDeptListOptions'] || [];
      this.drugUntOptions = this.$store.getters['preload/getDrugUntOptions'] || [];
      this.drugDosageOption = this.$store.getters['preload/getDrugDosageListOption'] || [];
      this.systemParameterList = this.$store.getters['preload/getSystemListOptions'] || [];

      try {
        const dictRes = await this.$store.dispatch('fetchDictData');
        const dictMap = this.$store.state.dict || {};
        if (dictMap.ruteVo) {
          this.medicationWayOptions = dictMap.ruteVo.map(item => ({ id: item.id, label: item.name }));
        }
      } catch (e) {}

      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));

      this.loadHistoryPaymentMethods();
    } catch (error) {
      console.error('预加载数据失败:', error);
    }

    this.fetchDocumentNo();
  },

  beforeDestroy() {
    clearTimeout(this.patientNameTimer);
    this.patientNameTimer = null;
    clearTimeout(this.drugSearchTimer);
    this.drugSearchTimer = null;
  },

  methods: {
    // ============================================================
    // ============ 打印处方 ============
    // ============================================================

    getSaleUnitName(row) {
      if (!row || !row.saleUntOption || !row.saleUnt) return '';
      const opt = row.saleUntOption.find(o => o.id === row.saleUnt);
      return opt ? opt.label : '';
    },

    generatePrescriptionHtml(items) {
      const renderDrugItem = (item) => {
        const medcWay = (this.medicationWayOptions || []).find(opt => opt.id === item.routeId)?.label || '';
        const usedfrqu = '';

        const sigParts = [
          item.singleDose && item.doseUnit ? `${item.singleDose}${item.doseUnit}` : '',
          medcWay,
          usedfrqu
        ].filter(Boolean).join(' ');

        const sigText = `${sigParts}${item.periodDays ? ` ${item.periodDays}天` : ''}`;

        return `
        <div style="margin: 6px 0; line-height: 1.2; font-family: '仿宋'; font-size: 16px;">
            <span style="color: #333; font-weight: bold; display: inline-block; width: 140px; text-align: right; margin-right: 25px;">${item.itemName || ''}</span>
            <span style="color: #000000; display: inline-block; width: 140px; margin-right: 25px;">${item.specification || ''}</span>
            <span style="color: #000000; display: inline-block; width: 100px;">共${item.quantity ?? ''}${item.unitName || ''}</span>
            ${sigText ? `<div style="margin-left: 165px; color: #000000;">Sig: ${sigText}</div>` : ''}
        </div>
      `;
      };

      const itemsHtml = (items || []).map(renderDrugItem).join('');

      return `
      <div style="font-weight: bold; font-size: 12px; margin-bottom: 8px; font-family: '仿宋';">Rp:</div>
      <div style="padding-left: 8px;">${itemsHtml}</div>
    `;
    },

    async planRetailPrescriptionData(items) {
      let clinic = [];
      try {
        const clinicData = await doccliniclist();
        clinic = (clinicData.data || []).map(item => ({
          id: item.id,
          label: item.name
        }));
      } catch (e) {
        console.warn('获取诊所列表失败:', e);
      }

      const printItems = items.map(row => ({
        itemName: row.drugName || '',
        specification: row.pacSpec || '',
        quantity: row.cnt ?? '',
        unitName: this.getSaleUnitName(row),
        singleDose: '',
        doseUnit: '',
        routeId: null,
        frequencyId: null,
        periodDays: '',
        remark: row.remark || ''
      }));

      const deptLabel = (this.deptOptions || [])
          .find(item => item.id === this.userInfo?.selDept)?.label || '';

      const patientName = this.patientForm.name || '零售购药';

      return {
        clinicPrescriptionName: (clinic.find(item => item.id === this.userInfo?.clinicId)?.label || '') + '处方笺',
        isGrowUp: '成人',
        rxType: '普通处方',
        patId: this.patientForm.certno || '',
        prhCostType: '自费',
        name: patientName,
        sex: '',
        age: '',
        dept: deptLabel,
        seedoctorId: '',
        date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        address: '',
        westernDiagnos: '',
        remake: '',
        doctor: this.userInfo?.staffName || '',
        prescriptionAmount: Number(this.totalAmount || 0).toFixed(2),
        phayId: '西药房',
        medicineGroups: this.generatePrescriptionHtml(printItems),
        code: this.retailOrderNo || ''
      };
    },

    async handlePrintWestPrescription() {
      const validRows = this.westMedicineTableData.filter(r => r.drugId && Number(r.cnt) > 0);
      if (validRows.length === 0) {
        this.$message.warning('请先填写药品信息后再打印');
        return;
      }

      await withLoading(this, '正在准备打印...')(async () => {
        try {
          const printData = await this.planRetailPrescriptionData(validRows);
          printUtil.init(westPrescription);
          printUtil.print(printData);
        } catch (error) {
          console.error('打印失败:', error);
          this.$message.error('打印失败，请重试');
        }
      });
    },

    // ============================================================
    // ============ 原有方法 ============
    // ============================================================

    getPatientAge(row) {
      if (!row) return '-';
      if (row.age !== null && row.age !== undefined && row.age !== '') {
        return row.age;
      }
      const brdy = row.brdy;
      if (!brdy) return '-';
      const birth = dayjs(brdy);
      if (!birth.isValid()) return '-';
      const age = dayjs().diff(birth, 'year');
      return age >= 0 ? age : '-';
    },

    async fetchDocumentNo() {
      if (this.documentNoLoading) return;
      this.documentNoLoading = true;
      try {
        const res = await getDocumentNo({ documentType: 'LS' });
        const ok = res && (res.code === 200 || res.code === 0 || res.success === true);
        if (ok && res.data) {
          this.retailOrderNo = typeof res.data === 'string'
              ? res.data
              : (res.data.documentNo || res.data.orderNo || res.data.no || '');
        } else {
          console.warn('获取零售单号失败:', res && res.message);
        }
      } catch (e) {
        console.error('获取零售单号异常:', e);
      } finally {
        this.documentNoLoading = false;
      }
    },

    async refreshDocumentNo() {
      this.retailOrderNo = '';
      await this.fetchDocumentNo();
    },

    resetPatientForm() {
      clearTimeout(this.patientNameTimer);
      this.patientNameTimer = null;
      this.patientNameComposing = false;

      this.patientForm = getEmptyPatientForm();
      this.clearMatchedPatient(false);
      this.patientResolvedName = '';
      this.patientMatchList = [];
      this.patientMatchKeyword = '';
    },

    handlePatientNameInput() {
      if (this.selectedPatientId || this.selectedPatient) {
        this.clearMatchedPatient(false);
      }
      if (this.patientResolvedName) {
        this.patientResolvedName = '';
      }
      if (this.patientNameComposing) return;
      this.schedulePatientMatch();
    },

    handleNameCompositionStart() {
      this.patientNameComposing = true;
      clearTimeout(this.patientNameTimer);
      this.patientNameTimer = null;
    },

    handleNameCompositionEnd() {
      this.patientNameComposing = false;
      this.schedulePatientMatch();
    },

    handlePatientCertInput() {
      if (this.selectedPatientId || this.selectedPatient) {
        this.clearMatchedPatient(false);
      }
      if (this.patientResolvedName) {
        this.patientResolvedName = '';
      }
    },

    handlePatientNameClear() {
      clearTimeout(this.patientNameTimer);
      this.patientNameTimer = null;
      this.clearMatchedPatient(false);
      this.patientResolvedName = '';
      this.patientMatchList = [];
      this.patientMatchKeyword = '';
    },

    schedulePatientMatch() {
      clearTimeout(this.patientNameTimer);
      const name = (this.patientForm.name || '').trim();
      if (name.length < 2) return;
      this.patientNameTimer = setTimeout(() => {
        this.patientNameTimer = null;
        this.tryMatchPatient();
      }, 600);
    },

    handlePatientNameBlur() {
      clearTimeout(this.patientNameTimer);
      this.patientNameTimer = null;
      this.tryMatchPatient();
    },

    handlePatientNameEnter() {
      clearTimeout(this.patientNameTimer);
      this.patientNameTimer = null;
      this.tryMatchPatient();
    },

    async tryMatchPatient() {
      const condition = (this.patientForm.name || '').trim();
      if (!condition) {
        this.clearMatchedPatient(false);
        this.patientResolvedName = '';
        return;
      }
      if (this.patientResolvedName === condition) return;
      if (this.patientQuerying) return;

      this.patientQuerying = true;
      try {
        const params = { condtion: condition };
        const certno = (this.patientForm.certno || '').trim();
        if (certno) params.certno = certno;

        const res = await getDocphrByCondtion(params);
        const ok = res && (res.code === 200 || res.code === 0 || res.success === true);
        if (!ok) {
          console.warn('查询患者信息失败:', res && res.message);
          return;
        }

        let list = [];
        if (Array.isArray(res.data)) {
          list = res.data;
        } else if (res.data && Array.isArray(res.data.content)) {
          list = res.data.content;
        } else if (res.data && Array.isArray(res.data.records)) {
          list = res.data.records;
        }

        if (!list.length) {
          this.clearMatchedPatient(false);
          this.patientResolvedName = condition;
          return;
        }

        if (list.length === 1) {
          this.applyMatchedPatient(list[0], true);
          return;
        }

        if (certno) {
          const exactList = list.filter(it => this.isSameCert(it.certno, certno));
          if (exactList.length === 1) {
            this.applyMatchedPatient(exactList[0], true);
            return;
          }
          if (exactList.length > 1) {
            this.openPatientMatchDialog(condition, exactList);
            return;
          }
        }

        this.openPatientMatchDialog(condition, list);
      } catch (error) {
        console.error('查询患者信息异常:', error);
      } finally {
        this.patientQuerying = false;
      }
    },

    isSameCert(certA, certB) {
      const a = (certA || '').toString().trim().toUpperCase();
      const b = (certB || '').toString().trim().toUpperCase();
      if (!a || !b) return false;
      return a === b;
    },

    isCertMatch(row) {
      if (!row) return false;
      return this.isSameCert(row.certno, this.patientForm.certno);
    },

    openPatientMatchDialog(name, list) {
      this.patientMatchKeyword = name;
      this.patientMatchList = list || [];
      this.patientMatchDialogVisible = true;
    },

    handlePatientMatchClosed() {
      this.patientMatchList = [];
    },

    chooseMatchedPatient(row) {
      if (!row) return;
      this.applyMatchedPatient(row, false);
    },

    applyMatchedPatient(patient, autoMatched) {
      this.selectedPatient = { ...patient, _age: this.getPatientAge(patient) };
      this.selectedPatientId = patient.id;

      this.patientForm.name = patient.name || this.patientForm.name;
      this.patientForm.tel = patient.tel || this.patientForm.tel;
      this.patientForm.certno = patient.certno || this.patientForm.certno;

      this.patientResolvedName = (this.patientForm.name || '').trim();
      this.patientMatchDialogVisible = false;

      if (autoMatched) {
        this.$message.success(`已匹配到患者【${patient.name}】`);
      } else {
        this.$message.success(`已选择患者【${patient.name}】`);
      }
    },

    confirmCreateNewPatient() {
      this.selectedPatient = null;
      this.selectedPatientId = null;
      this.patientResolvedName = (this.patientForm.name || '').trim();
      this.patientMatchDialogVisible = false;
      this.$message.info('提交时将按当前输入新增患者');
    },

    clearMatchedPatient(showMsg) {
      const had = !!this.selectedPatientId;
      this.selectedPatient = null;
      this.selectedPatientId = null;
      if (showMsg && had) {
        this.$message.info('已取消患者匹配，提交时将按当前输入新增患者');
      }
    },

    async createPatient() {
      if (!this.patientForm.name) {
        this.$message.warning('请输入患者姓名');
        throw new Error('缺少姓名');
      }
      if (this.patientForm.certno) {
        const idOk = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.patientForm.certno);
        if (!idOk) {
          this.$message.warning('身份证号格式不正确');
          throw new Error('身份证格式不正确');
        }
      }

      const thrNot = this.patientForm.certno ? 0 : 1;
      const payload = {
        name: this.patientForm.name,
        tel: this.patientForm.tel,
        ntlyId: 1,
        thrNot,
        createType: 1
      };
      if (this.patientForm.certno) {
        payload.certno = this.patientForm.certno;
        payload.certType = 1;
      }

      try {
        const res = await addDocphr(payload);
        const ok = res.code === 200 || res.code === 0 || res.success === true;
        if (ok) {
          const patientId = res.data?.id || res.data?.phrId || res.data;
          return patientId;
        }
        this.$message.error(res.message || '患者新增失败');
        throw new Error('患者新增失败');
      } catch (error) {
        if (!error.message || !error.message.includes('患者新增失败')) {
          this.$message.error('患者新增失败');
        }
        throw error;
      }
    },

    searchDrugsForRow(row, query) {
      if (!query || query.trim() === '') {
        this.$set(row, '_searchResults', []);
        this.$set(row, '_popoverVisible', false);
        return;
      }
      const keyword = query.trim();
      const isTraceCode = /^\d{15,}$/.test(keyword);
      const drugType = isTraceCode ? 4 : 1;

      clearTimeout(this.drugSearchTimer);

      const executeSearch = async () => {
        this.$set(row, '_searchLoading', true);
        try {
          const res = await getDrugByCondition({ drugType, condition: keyword });
          const results = (res.data || []).map(item => ({
            ...item,
            dugPurcId: item.drugId,
          }));
          this.$set(row, '_searchResults', results);
          if (results.length > 0) {
            this.$set(row, '_popoverVisible', true);
          } else {
            this.$set(row, '_popoverVisible', false);
            if (isTraceCode) {
              this.$message.warning('未找到该追溯码对应的药品');
            }
          }
        } catch (e) {
          this.$set(row, '_searchResults', []);
        } finally {
          this.$set(row, '_searchLoading', false);
        }
      };

      if (isTraceCode) {
        executeSearch();
      } else {
        this.drugSearchTimer = setTimeout(executeSearch, 300);
      }
    },

    handleSelectDrugFromPopover(row, drugData) {
      this.$set(row, '_popoverVisible', false);
      const drugId = drugData.drugId || drugData.id || drugData.dugPurcId;

      if (this.westMedicineTableData.some(item => (item.drugId === drugId) && item !== row)) {
        this.$message.warning(`药品【${drugData.drugName}】已存在`);
        return;
      }

      const currentInput = row.drugName?.trim() || '';
      const isTraceCode = /^\d{15,}$/.test(currentInput);
      if (isTraceCode) {
        this.submittedTraceCodes[drugId] = currentInput;
      }

      row.drugId = drugId;
      row.drugName = drugData.drugName;
      row.pacSpec = drugData.pacSpec || '';
      row.fixMinSalePric = drugData.fixMinSalePric || 0;
      row.fixPacSalePric = drugData.fixPacSalePric || 0;
      row.minUntId = drugData.minUntId;
      row.pacUntId = drugData.pacUntId;
      row.saleUnt = Number(drugData.saleUnt) === 2 ? drugData.pacUntId : drugData.minUntId;
      row.saleUntOption = [
        { id: drugData.minUntId, label: drugData.minUnt || '最小单位' },
        { id: drugData.pacUntId, label: drugData.pacUnt || '包装单位' }
      ];

      row.cnt = 1;
      row.remark = '';

      this.$set(row, '_searchResults', []);
      this.$set(row, '_searchKeyword', '');

      const currentIndex = this.westMedicineTableData.indexOf(row);
      if (currentIndex === this.westMedicineTableData.length - 1) {
        this.westMedicineTableData.push(getEmptyWestRowData());
      }

      this.calcWestRowAmount(row);
    },

    handleDrugNameEnter(rowIndex, row) {
      if (row._searchResults && row._searchResults.length > 0) {
        this.handleSelectDrugFromPopover(row, row._searchResults[0]);
      }
    },

    getUnitPrice(row) {
      if (row.saleUnt === row.minUntId) {
        return Number(row.fixMinSalePric || 0).toFixed(2);
      } else if (row.saleUnt === row.pacUntId) {
        return Number(row.fixPacSalePric || 0).toFixed(2);
      }
      return '0.00';
    },

    calcWestRowAmount(row) {
      const cnt = Number(row.cnt) || 0;
      const price = Number(this.getUnitPrice(row)) || 0;
      this.$set(row, 'saleAmt', parseFloat((cnt * price).toFixed(2)));
    },

    canRemoveWest() {
      return this.westMedicineTableData.length > 1 ||
          (this.westMedicineTableData[0] && this.westMedicineTableData[0].drugId);
    },

    removeWestMedicineTableData(index) {
      this.westMedicineTableData.splice(index, 1);
      if (this.westMedicineTableData.length === 0) {
        this.westMedicineTableData.push(getEmptyWestRowData());
      }
    },

    async handleConfirmWest() {
      const validRows = this.westMedicineTableData.filter(r => r.drugId);
      if (validRows.length <= 0) return this.$message.error("请选择处方");

      clearTimeout(this.patientNameTimer);
      this.patientNameTimer = null;
      const name = (this.patientForm.name || '').trim();
      if (name && !this.selectedPatientId && this.patientResolvedName !== name) {
        await this.tryMatchPatient();
        if (this.patientMatchDialogVisible) return;
      }

      await withLoading(this, '数据处理中...')(async () => {
        if (!this.retailOrderNo) {
          await this.fetchDocumentNo();
          if (!this.retailOrderNo) {
            this.$message.error('获取零售单号失败，请重试');
            return;
          }
        }

        let finalPatientId = null;

        if (this.selectedPatientId) {
          finalPatientId = this.selectedPatientId;
        } else if (this.hasPatientInput) {
          try {
            finalPatientId = await this.createPatient();
          } catch (e) {
            return;
          }
          if (!finalPatientId) return;
        } else {
          const generateRes = await generateHealthSystemId();
          if (generateRes.code !== 200) {
            this.$message.error(generateRes.message || "生成就诊信息失败");
            return;
          }
          finalPatientId = generateRes.data.patId;
        }

        const items = validRows.map(item => ({
          itemId: String(item.drugId),
          unitId: Number(item.saleUnt),
          quantity: Number(item.cnt),
          remark: item.remark || ''
        }));

        const requestData = {
          requestNo: this.generateUUID(),
          orderNo: this.retailOrderNo,
          patientId: finalPatientId,
          items: items
        };

        const res = await addOrdersRetail(requestData);

        if (!res || res.code !== 200) {
          this.$message.error("提交零售医嘱失败: " + ((res && res.message) || ''));
          return;
        }

        this.patientId = finalPatientId;
        this.westMedicineTableData = [getEmptyWestRowData()];

        this.$message.success("提交成功，正在为您加载订单...");
        await this.loadAndSettleLatestOrder(finalPatientId);
      });
    },

    async loadAndSettleLatestOrder(patientId) {
      try {
        const res = await getPatientsAwaitingPaymentByPatientId({ patientId });
        if (!res.data || res.data.length === 0) {
          this.$message.warning('未获取到待收费订单');
          return;
        }

        const latestOrder = res.data[res.data.length - 1];
        this.selectedOrderIds = [latestOrder.id];
        this.totalChargeAmount = latestOrder.totalAmount || 0;

        const displayName = (this.hasPatientInput && this.patientForm.name)
            ? this.patientForm.name
            : '零售购药';

        this.outpatientChargesForm.currentTotal = this.totalChargeAmount;
        this.outpatientChargesForm.patId = patientId;
        this.outpatientChargesForm.name = displayName;

        this.paymentForm.patId = patientId;
        this.paymentForm.patName = displayName;
        this.paymentForm.cashAmt = this.totalChargeAmount;
        this.paymentForm.recdAmt = this.totalChargeAmount;
        this.paymentForm.change = '0.00';

        try {
          const balanceRes = await getAmtById(patientId);
          if (balanceRes.code === 200 && balanceRes.data) {
            this.currentRecahrgeAmt = (balanceRes.data.recahrgeAmt || 0).toFixed(2);
            this.currentHandselAmt = (balanceRes.data.handselAmt || 0).toFixed(2);
          }
        } catch (e) {}

        await this.loadPaymentMethods();
        this.settleAccountsDialogVisible = true;
      } catch (error) {
        console.error('加载结算数据失败:', error);
        this.$message.error('加载结算数据失败');
      }
    },

    async loadPaymentMethods() {
      try {
        const res = await getPatternPaymentList();
        if (res.code === 200) {
          this.dynamicPaymentMethods = res.data;
          this.initDynamicPaymentValues();
        }
      } catch (error) {
        console.error('加载支付方式失败:', error);
      }
    },

    initDynamicPaymentValues() {
      this.dynamicPaymentValues = {};
      this.dynamicPaymentMethods.forEach(method => {
        this.$set(this.dynamicPaymentValues, method.id, 0);
      });
      if (this.dynamicPaymentMethods.length > 0) {
        const cashMethod = this.dynamicPaymentMethods.find(m => m.wayName.includes('现金') || m.wayCode === 'XJ');
        if (cashMethod) {
          this.$set(this.dynamicPaymentValues, cashMethod.id, this.totalChargeAmount);
        }
      }
      this.calculateDynamicPayments();
    },

    calculateDynamicPayments() {
      this.dynamicPaymentMethods.forEach(method => {
        let val = this.dynamicPaymentValues[method.id];
        if (val === null || val === undefined || isNaN(val) || val < 0) {
          this.dynamicPaymentValues[method.id] = 0;
        } else {
          this.dynamicPaymentValues[method.id] = Number(Number(val).toFixed(2));
        }
      });

      let totalPaid = 0;
      this.dynamicPaymentMethods.forEach(method => {
        totalPaid += Number(this.dynamicPaymentValues[method.id]) || 0;
      });
      this.paymentForm.recdAmt = totalPaid.toFixed(2);
      const shouldPay = Number(this.outpatientChargesForm.currentTotal) || 0;
      const change = totalPaid - shouldPay;
      this.paymentForm.change = change >= 0 ? change.toFixed(2) : '0.00';
    },

    onRecdAmtChange(val) {
      const recd = Number(val) || 0;
      const shouldPay = Number(this.outpatientChargesForm.currentTotal) || 0;
      const change = recd - shouldPay;
      this.paymentForm.change = change >= 0 ? change.toFixed(2) : '0.00';
      if (this.dynamicPaymentMethods.length > 0) {
        const firstId = this.dynamicPaymentMethods[0].id;
        this.dynamicPaymentValues[firstId] = recd;
        this.calculateDynamicPayments();
      }
    },

    handleAssignPayment(methodId) {
      const shouldPay = Number(this.outpatientChargesForm.currentTotal) || 0;
      let otherTotal = 0;
      this.dynamicPaymentMethods.forEach(method => {
        if (method.id !== methodId) {
          otherTotal += Number(this.dynamicPaymentValues[method.id]) || 0;
        }
      });
      let remaining = shouldPay - otherTotal;
      if (remaining < 0) remaining = 0;
      if (remaining === 0) {
        this.$message.warning('当前已足额支付，无需再分配');
        return;
      }
      this.dynamicPaymentValues[methodId] = Number(remaining.toFixed(2));
      this.calculateDynamicPayments();
    },

    async handleConfirmCharge() {
      try {
        this.chargeLoading = true;

        const payWay = [];
        this.dynamicPaymentMethods.forEach(method => {
          const amount = Number(this.dynamicPaymentValues[method.id]) || 0;
          if (amount > 0) {
            payWay.push({
              amount: amount,
              payWayId: method.id,
              externalTradeNo: '',
              requestNo: this.generateUUID(),
              remark: ''
            });
          }
        });

        const totalPaid = Object.values(this.dynamicPaymentValues).reduce((sum, val) => sum + (Number(val) || 0), 0);
        const shouldPay = this.totalChargeAmount;

        if (totalPaid <= 0) {
          this.$message.warning("请确认支付金额");
          return;
        }

        if (Math.abs(totalPaid - shouldPay) > 0.01) {
          this.$message.warning("支付金额与应收金额不匹配");
          return;
        }

        const requestData = {
          orderIds: this.selectedOrderIds,
          payments: payWay,
          remark: this.paymentForm.remarks || '',
          requestNo: this.generateRequestNo()
        };

        const res = await fullOrderCharge(requestData);

        if (res.code === 200) {
          this.$message.success('收费成功');
          this.settleAccountsDialogVisible = false;
          this.clearRequestNo();
          this.handlePaymentComplete();
        } else {
          this.$message.error(res.message || '收费失败');
        }
      } catch (error) {
        console.error('收费失败:', error);
        this.$message.error('收费失败，请重试');
      } finally {
        this.chargeLoading = false;
      }
    },

    handleClosePayment() {
      this.settleAccountsDialogVisible = false;
      this.paymentForm = getEmptyPaymentForm();
      this.dynamicPaymentValues = {};
      this.currentRecahrgeAmt = '0.00';
      this.currentHandselAmt = '0.00';
    },

    handlePaymentDialogClosed() {
      this.dynamicPaymentMethods = [];
      this.dynamicPaymentValues = {};
      this.currentRecahrgeAmt = '0.00';
      this.currentHandselAmt = '0.00';
    },

    async handlePaymentComplete() {
      await withLoading(this, '正在获取发药订单...')(async () => {
        try {
          const res = await getPatientInfoV2({ patientId: this.patientId });
          if (!res.data || res.data.length === 0) {
            this.$message.warning('未查询到待发药处方');
            return;
          }
          const latestOrder = res.data[res.data.length - 1];
          await this.doFySave(latestOrder);
        } catch (error) {
          console.error('获取发药信息失败:', error);
          this.$message.error('获取发药信息失败');
        }
      });
    },

    async doFySave(order) {
      await withLoading(this, '正在执行发药...')(async () => {
        try {
          const items = order.items || [];
          const listPromises = items.map(async (item) => {
            let tracCodeJson = item.tracCodeJson || '';
            const realBarcode = this.submittedTraceCodes[item.itemId] || "";

            if (!tracCodeJson) {
              try {
                const batchRes = await outpTable({ orderItemId: item.id });
                let targetBatch = null;

                if (batchRes.data && batchRes.data.length > 0) {
                  targetBatch = batchRes.data[0];

                  if (realBarcode) {
                    const detailRes = await msfxCodeDetail({ codes: realBarcode });
                    if (detailRes.code === 200 && detailRes.data && detailRes.data.length > 0) {
                      const data = detailRes.data[0];
                      const traceBatchNo = data.codeProduceInfoDTO?.produceInfoList?.[0]?.batchNo || '';
                      const traceApprovalNo = data.drugEntBaseDTO?.approvalLicenceNo || '';

                      const matched = batchRes.data.find(b =>
                          b.approvalNumber === traceApprovalNo &&
                          b.manuLotnum === traceBatchNo
                      );
                      if (matched) {
                        targetBatch = matched;
                      }
                    }
                  }
                }

                if (targetBatch) {
                  const chgCnt = parseInt(item.quantity) || 1;
                  let chgCntForBackend = chgCnt;

                  if (item.unitId === targetBatch.pacUntId) {
                    chgCntForBackend = chgCnt * parseInt(targetBatch.pacCnt || 1);
                  }

                  tracCodeJson = JSON.stringify([{
                    barcode: realBarcode,
                    chgCnt: chgCntForBackend,
                    manuLotnum: targetBatch.manuLotnum,
                    tableId: targetBatch.tableId
                  }]);
                }
              } catch (e) {
                console.error(`自动获取药品【${item.itemName}】批次失败`, e);
              }
            }

            return {
              orderItemId: item.id,
              tracCodeJson: tracCodeJson
            };
          });

          const list = await Promise.all(listPromises);
          const payload = {
            orderId: order.id,
            requestNo: this.generateUUID(),
            list: list
          };

          const fyRes = await fySaveV2(payload);

          if (fyRes.code === 200) {
            this.$message.success('发药成功！');

            const allTraceCodes = [];
            list.forEach(item => {
              if (item.tracCodeJson) {
                try {
                  const parsed = JSON.parse(item.tracCodeJson);
                  if (Array.isArray(parsed)) {
                    parsed.forEach(p => {
                      if (p.barcode && p.barcode !== '') {
                        allTraceCodes.push(p.barcode);
                      }
                    });
                  }
                } catch (e) {}
              }
            });

            const uniqueTraceCodes = [...new Set(allTraceCodes)];
            const traceCodesStr = uniqueTraceCodes.join(',');

            if (traceCodesStr) {
              try {
                const uploadRes = await uploadRetail({
                  billType: 321,
                  bizNum: order.orderNo || this.generateUUID(),
                  traceCodes: traceCodesStr
                });
                if (uploadRes.code === 200) {
                  this.$message.success('追溯码上传成功！');
                } else {
                  this.$message.warning(`追溯码上传失败：${uploadRes.message}`);
                }
              } catch (e) {
                this.$message.warning('追溯码上传异常，请稍后重试');
              }
            } else {
              console.log('本次发药不包含追溯码，跳过上传');
            }

            this.resetPatientForm();
            this.submittedTraceCodes = {};

            this.refreshDocumentNo();
          } else {
            this.$message.error(`发药失败：${fyRes.message || '未知错误'}`);
          }
        } catch (error) {
          console.error('发药失败:', error);
          this.$message.error('发药发生异常');
        }
      });
    },

    async loadHistoryPaymentMethods() {
      try {
        const res = await getPatternPaymentList();
        if (res.code === 200) {
          this.paymentMethodOptions = res.data || [];
        }
      } catch (error) {
        console.error('加载支付方式失败:', error);
      }
    },

    openOrderList() {
      this.orderListDialogVisible = true;
      this.orderListPageNum = 1;
      this.loadOrderListData();
    },

    handleOrderListSearch() {
      this.orderListPageNum = 1;
      this.loadOrderListData();
    },

    handleOrderListReset() {
      this.orderListSearchForm = {
        chargeNo: '',
        patientName: '',
        chargeType: null,
        status: null,
        timeRange: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      };
      this.orderListPageNum = 1;
      this.loadOrderListData();
    },

    async loadOrderListData() {
      this.orderListLoading = true;
      try {
        const params = {
          pageNum: this.orderListPageNum,
          pageSize: this.orderListPageSize,
          chargeNo: this.orderListSearchForm.chargeNo || undefined,
          patientName: this.orderListSearchForm.patientName || undefined,
          chargeType: this.orderListSearchForm.chargeType || undefined,
          status: this.orderListSearchForm.status || undefined,
          startTime: this.orderListSearchForm.timeRange?.[0] || undefined,
          endTime: this.orderListSearchForm.timeRange?.[1] || undefined
        };

        const res = await getChargesQuery(params);
        if (res.code === 200) {
          this.orderListTableData = res.data?.content || [];
          this.orderListTotalSize = res.data?.totalSize || 0;
        } else {
          this.$message.error(res.message || '查询失败');
        }
      } catch (error) {
        console.error('加载订单列表失败:', error);
        this.$message.error('加载订单列表失败');
      } finally {
        this.orderListLoading = false;
      }
    },

    handleOrderListSizeChange(val) {
      this.orderListPageSize = val;
      this.loadOrderListData();
    },

    handleOrderListCurrentChange(val) {
      this.orderListPageNum = val;
      this.loadOrderListData();
    },

    handleOrderListClosed() {
      this.orderListTableData = [];
      this.orderListTotalSize = 0;
      this.orderListPageNum = 1;
    },

    async handleOrderRowDblclick(row) {
      if (!row) return;

      this.detailDialogVisible = true;
      this.detailLoading = true;
      this.detailPrescriptionType = 'other';
      this.detailData = {
        ...getEmptyDetailData(),
        chargeNo: row.chargeNo || '',
        patientName: row.patientName || '',
        chargeTime: row.chargeTime || '',
        status: row.status,
        paidAmount: row.paidAmount || 0
      };

      try {
        const res = await getRefundableCharges({ chargeId: row.id });
        if (res.code === 200) {
          const data = res.data || {};
          const items = data.items || [];
          const paidAmount = items.reduce((sum, it) => sum + (it.paidAmount || 0), 0)
              || row.paidAmount || 0;

          this.detailData = {
            chargeId: data.chargeId || row.id,
            chargeNo: data.chargeNo || row.chargeNo,
            patientName: data.patientName || row.patientName,
            chargeTime: data.chargeTime || row.chargeTime,
            status: data.status ?? row.status,
            paidAmount,
            refundableAmount: data.refundableAmount || 0,
            refundedAmount: data.refundedAmount || 0,
            items,
            payments: data.payments || []
          };
          this.detailPrescriptionType = this.getPrescriptionType(items);
        } else {
          this.$message.error(res.message || '加载详情失败');
          this.detailDialogVisible = false;
        }
      } catch (error) {
        console.error('加载详情失败:', error);
        this.$message.error('加载详情失败');
        this.detailDialogVisible = false;
      } finally {
        this.detailLoading = false;
      }
    },

    handleDetailClosed() {
      this.detailData = getEmptyDetailData();
      this.detailPrescriptionType = 'other';
    },

    getDetailPayWayLabel(payWayId) {
      const method = this.paymentMethodOptions.find(item => item.id === payWayId);
      return method?.wayName || `支付方式(${payWayId})`;
    },

    getDetailUnitPrice(row) {
      if (row.unitPrice !== undefined && row.unitPrice !== null) {
        return Number(row.unitPrice) || 0;
      }
      const qty = row.chargedQty || 0;
      if (qty <= 0) return 0;
      return (row.paidAmount || 0) / qty;
    },

    getPrescriptionType(items) {
      if (!items || items.length === 0) return 'other';
      const types = new Set(items.map(item => item.itemType));
      const hasDrug = types.has(1) || types.has(2) || types.has(5) || types.has(6);
      const hasTreatment = types.has(4) || types.has(7) || types.has(8);
      const hasTcm = types.has(2);
      const hasInfusion = types.has(6);
      const hasWestern = types.has(1) || types.has(5);

      if (hasDrug && hasTreatment) return 'mixed';
      if (hasTcm && !hasWestern && !hasInfusion) return 'tcm';
      if (hasInfusion && !hasWestern && !hasTreatment) return 'infusion';
      if (hasWestern && !hasInfusion && !hasTreatment) return 'western';
      if (hasTreatment && !hasDrug) return 'treatment';
      if (hasInfusion && hasWestern) return 'infusion';
      return 'other';
    },

    getPrescriptionTypeLabel(type) {
      const map = {
        western: '西药处方',
        tcm: '中药处方',
        infusion: '输液处方',
        treatment: '处置处方',
        mixed: '混合处方',
        other: '其他'
      };
      return map[type] || '其他';
    },

    getStatusType(status) {
      const map = { 1: 'success', 2: 'warning', 3: 'danger' };
      return map[status] || 'info';
    },

    getStatusLabel(status) {
      const map = { 1: '已收费', 2: '部分退款', 3: '全额退款' };
      return map[status] || '未知';
    },

    getItemTypeLabel(type) {
      const map = {
        1: '西药',
        2: '中药',
        4: '理疗',
        5: '卫材',
        6: '输液/治疗',
        7: '检查',
        8: '检验',
        9: '挂号费',
        10: '其他'
      };
      return map[type] || '其他';
    },

    getSexLabel(sex) {
      const map = { 1: '男', 2: '女', 0: '未知', 9: '未说明' };
      return map[sex] || '-';
    },

    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    generateRequestNo() {
      if (this.cachedRequestNo) return this.cachedRequestNo;
      this.cachedRequestNo = this.generateUUID();
      return this.cachedRequestNo;
    },
    clearRequestNo() {
      this.cachedRequestNo = null;
    },

    getColumnWidth(label, prop, tableData) {
      if (!tableData || !tableData.length) return 120;
      const minWidth = 100;
      const padding = 30;
      const texts = [...tableData.map(item => item?.[prop] ?? ''), label];
      const maxWidth = Math.max(...texts.map(t => this.getTextWidth(String(t)) + padding));
      return Math.max(minWidth, maxWidth);
    },

    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    },

    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue == null) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },
  }
};
</script>

<style lang="less" scoped>
.prescription-container {
  width: 100%;
  height: 100vh;
  background-color: #f0f7ff;
  padding: 20px;

  .prescription-layout {
    display: flex;
    height: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .prescription-left {
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .prescription-header-card {
        height: 100%;
        border: none;
        border-radius: 0;

        /deep/ .el-card__header {
          padding: 12px 20px;
          background: linear-gradient(135deg, #1890ff 0%, #36cbcb 100%);
          border-bottom: none;

          .card-header {
            position: relative;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            min-height: 32px;

            .header-title {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              text-align: center;
              white-space: nowrap;
              pointer-events: none;

              .retail-title {
                font-size: 18px;
                font-weight: 600;
                color: #fff;
                letter-spacing: 4px;
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
              }
            }
          }
        }

        /deep/ .el-card__body {
          height: calc(100% - 60px);
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .prescription-form {
            flex: 1;
            overflow: auto;
          }
        }
      }
    }
  }
}

.header-actions { display: flex; align-items: center; gap: 8px; position: relative; z-index: 2; }
.header-actions .el-button { color: white; padding: 6px 16px; }

.patient-input-section {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 12px;
  margin-bottom: 12px;
  background: #f8f9fa;
  border: 1px solid #ebeef5;
  border-left: 3px solid #409EFF;
  border-radius: 4px;

  .section-label {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-right: 4px;
    white-space: nowrap;
  }
}

.order-no-display {
  /deep/ .el-input__inner {
    background-color: #ecf5ff;
    color: #409EFF;
    font-weight: 600;
    letter-spacing: 1px;
    cursor: default;
    border-color: #b3d8ff;
  }
}

.patient-match-dialog {
  .match-tip {
    font-size: 13px;
    color: #606266;
    padding: 8px 12px;
    margin-bottom: 10px;
    background: #f4f8ff;
    border: 1px solid #d9ecff;
    border-left: 3px solid #409EFF;
    border-radius: 4px;

    .match-name {
      color: #409EFF;
      font-weight: bold;
    }
    .match-count {
      color: #E6A23C;
      font-weight: bold;
      padding: 0 2px;
    }
  }
}

.payment-form { background: #f5f5f5; padding: 20px; border-radius: 4px; }
.form-section { background: white; padding: 15px; margin-bottom: 15px; border-radius: 4px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); }
.payment-summary { background: #f5f7fa; padding: 10px; border-radius: 4px; margin-top: 15px; }
.amount { color: #f56c6c; font-weight: bold; display: inline-block; width: 120px; text-align: left; }
.form-actions { text-align: center; margin-top: 20px; }

:deep(.el-table--mini) { font-size: 12px; }
/deep/ .el-dialog__header { padding: 12px; background-color: #007bb0; }
/deep/ .el-dialog__title { font-size: 14px; color: #fff; }

.assign-btn {
  cursor: pointer;
  color: #409eff;
  font-size: 12px;
  line-height: 28px;
  margin-right: 5px;
  user-select: none;
}
.assign-btn:hover {
  color: #66b1ff;
}

.order-list-dialog {
  .order-list-wrap {
    display: flex;
    flex-direction: column;
    height: 65vh;
  }

  .order-search-bar {
    flex-shrink: 0;
    background: #f8f9fa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 8px 12px 2px 12px;
    margin-bottom: 10px;

    /deep/ .el-form-item {
      margin-bottom: 6px;
    }
    /deep/ .el-form-item__label {
      font-size: 12px;
      padding-right: 6px;
    }
  }

  .order-list-table-wrap {
    flex: 1;
    min-height: 0;

    /deep/ .el-table {
      height: 100% !important;

      .el-table__body-wrapper {
        overflow-y: auto;
      }
    }
  }

  .order-pagination {
    flex-shrink: 0;
    padding-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
}

.detail-dialog {
  /deep/ .el-dialog__body {
    padding: 10px 15px;
  }

  .detail-layout {
    height: 70vh;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .detail-header {
      flex-shrink: 0;
      background: #f8f9fa;
      border-radius: 4px;
      padding: 8px 12px;
      border: 1px solid #e8ecf1;

      /deep/ .el-form-item {
        margin-bottom: 4px;
      }
      /deep/ .el-form-item__label {
        font-size: 12px;
        padding-right: 4px;
      }
      /deep/ .el-input.is-disabled .el-input__inner {
        color: #303133;
        background-color: transparent;
        border: none;
        padding-left: 0;
      }
    }

    .detail-body {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      border: 1px solid #e8ecf1;
      border-radius: 4px;
      overflow: hidden;

      .panel-title {
        flex-shrink: 0;
        padding: 6px 12px;
        background: #f8f9fa;
        border-bottom: 1px solid #e8ecf1;
        font-weight: bold;
        font-size: 14px;
      }

      .detail-table-wrap {
        flex: 1;
        min-height: 0;

        /deep/ .el-table {
          height: 100% !important;

          .el-table__body-wrapper {
            overflow-y: auto;
          }
        }
      }
    }

    .detail-body:last-child {
      flex: 0 0 200px;
    }
  }
}
</style>